import { useBlockNoteEditor, useComponentsContext, useEditorState } from '@blocknote/react';
import { Icon } from '../components/ui';
import { convertibleFileId } from '@harvus/shared';

// =============================================================
// ConvertFileButton — "Convert handwriting to text" in BlockNote's toolbar,
// shown over a selected PDF or photo that lives in the note. Rendered through
// NoteBodyEditor's `formattingToolbarExtras`; the read itself is the Notes
// app's (`onConvert(block)`), so this component only decides whether it shows.
// =============================================================

export function ConvertFileButton({ onConvert, busy }) {
  const editor = useBlockNoteEditor();
  const Components = useComponentsContext();
  const block = useEditorState({
    editor,
    selector: ({ editor: ed }) => {
      if (!ed.isEditable) return undefined;
      let blocks;
      try { blocks = ed.getSelection()?.blocks || [ed.getTextCursorPosition().block]; } catch { return undefined; }
      if (blocks.length !== 1) return undefined;
      return convertibleFileId(blocks[0]) ? blocks[0] : undefined;
    },
  });
  if (!block) return null;
  const label = busy ? 'Reading the handwriting…' : 'Convert handwriting to text';
  return (
    <Components.FormattingToolbar.Button
      className="bn-button"
      label={label}
      mainTooltip={label}
      isDisabled={!!busy}
      icon={<Icon name="scanText" size={16} />}
      onClick={() => { if (!busy) onConvert(block); }}
    />
  );
}
